/** @jsxImportSource @emotion/react */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { accessAPI, Titulo, tituloBase } from "../../../shared/index.js";
import { Skeleton } from "primereact/skeleton";
import CardSitios from "./CardSitios.js";

export default function ClienteSitios() {
  const { clienteId } = useParams();
  const [razonsocial, setRazonsocial] = useState("");
  const [sitios, setSitios] = useState(null);

  function cargarSitios() {
    accessAPI(
      "GET",
      `admin/sitio/cliente/${clienteId}`,
      null,
      (respuesta) => setSitios(respuesta),
      () => setSitios([])
    );
  }

  useEffect(() => {
    accessAPI(
      "GET",
      `admin/cliente/${clienteId}`,
      null,
      (respuesta) => {
        setRazonsocial(respuesta.razonsocial);
        document.title = `${respuesta.razonsocial} - Sitios`;
      },
      () => {}
    );
    cargarSitios();
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clienteId]);

  if (!razonsocial || sitios === null) {
    return (
      <div
        css={{
          marginTop: "2em",
          display: "flex",
          flexDirection: "column",
          gap: "1em"
        }}
      >
        <Skeleton width="20rem" height="2rem" />
        <Skeleton width="100%" height="15rem" />
      </div>
    );
  }

  return (
    <>
      <Titulo>{razonsocial} - Sitios</Titulo>
      <CardSitios
        clienteId={parseInt(clienteId)}
        sitios={sitios}
        onSitiosChanged={cargarSitios}
      />
    </>
  );
}
